export default "__VITE_ASSET__BwQ7caEv__"